

export const modal_helpers = {
	data(){
		return {
			formMsg: []
		}
	},
	methods: {
		//Short cuts for modals handling
		addModal(modalName){
			this.$store.commit('addModal', modalName);
		},
		removeModal(modalName){
			this.$store.commit('removeModal', modalName);
		},
		isModalLastActive(modalName){
			let mdl =  this.$store.state.modals;

			return mdl.length > 0 &&  mdl[mdl.length - 1] === modalName;
			//return this.$store.state.modals.some( el => el === modalName);
		},
	}
};